import { RouterSelectors } from '@next/core-lib/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { SettingModuleState } from '../../models/setting.model';
import { barnAdapter } from '../reducers/setting.reducer';
import { sensorActuatorBarnAdapter } from '../reducers/setting.reducer';

const { selectAll: selectAllBarns } = barnAdapter.getSelectors();

const { selectAll: selectAllSensorActuatorBarns } = sensorActuatorBarnAdapter.getSelectors();

export const getSettingModuleState = createFeatureSelector<SettingModuleState>('settingModule');

export const getBarnState = createSelector(getSettingModuleState, (state) => state.barns);

export const getSensorActuatorState = createSelector(
  getSettingModuleState,
  (state) => state.sensorActuatorBarns,
);

export const getSelectedBarnId = createSelector(RouterSelectors.getMergedRoute, (state) =>
  !isNaN(parseInt(state.params['barnId'], 10)) ? parseInt(state.params['barnId'], 10) : undefined,
);

export const getBarns = createSelector(getBarnState, selectAllBarns);

export const getBarnsAreaSum = createSelector(getBarns, (barns) =>
  barns ? barns.reduce((acc, curr) => acc + curr.surfaceArea, 0) : 0,
);

export const getSelectedBarn = createSelector(getSettingModuleState, (state) => state.selectedBarn);

export const isDuplicateBarnName = createSelector(
  getBarns,
  getSelectedBarnId,
  (barns, selectedBarnId) => (name: string) =>
    !!barns && barns.findIndex((b) => b.name === name && b.id !== selectedBarnId) !== -1,
);

export const getObservationSwitchSetting = createSelector(
  getSettingModuleState,
  (state) => state.observationSwitch,
);

export const getRVSSettings = createSelector(getSettingModuleState, (state) => state.rvsSettings);

export const getFarmResultSettings = createSelector(
  getSensorActuatorState,
  selectAllSensorActuatorBarns,
);

export const getDayOffset = createSelector(getSettingModuleState, (state) => state?.dayOffset);

export const getUnitOfMeasureSettings = createSelector(
  getSettingModuleState,
  (state) => state?.unitOfMeasureSettings,
);

export const getVeterinarianSettings = createSelector(
  getSettingModuleState,
  (state) => state?.veterinarianSettings,
);

export const getFinalSetupSettings = createSelector(
  getSettingModuleState,
  (state) => state?.finalSetupSettings,
);

export const getDiscountSettings = createSelector(
  getSettingModuleState,
  (state) => state?.discountSettings,
);
